export enum BlockReason {
  CREDIT_AND_FINANCIAL = "Credit and Financial Risk",
  COMPLIANCE_AND_REGULATORY = "Compliance and Regulatory",
  BUSINESS_PROFILE_RISK = "Business Profile Risk",
  INTERNAL_POLICY = "Internal Policy",
  FRAUDULENT_APPLICATION = "Fraudulent Application",
  FRAUDULENT_BUSINESS = "Fraudulent Business",
  OTHER = "Other",
}
